module.exports = __webpack_public_path__ + "static/media/xiaoshuoming.df154025.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/xiaoshuoming.png
// module id = 1903
// module chunks = 0 1